import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_LINE_ITEM } from '../../../../../../../constants'
import { getFeatureFromCache } from '../../../../../../../util/feature-cache'
import {
  FulfilmentSelect as FulfilmentSelectUnified,
  FulfilmentSelectProps,
} from '../../../../../../sale/sale-line-item/FulfilmentSelect'
import { FulfilmentSelectLegacy } from './FulfilmentSelectLegacy'

// After removing uc_in_webregister_line_item, make this index export the new component
// directly from sale/sale-line-item/fulfilment-select.
export const FulfilmentSelect: React.FC<FulfilmentSelectProps> = props => {
  const isUnifiedFulfilmentUiEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_LINE_ITEM
  )

  return isUnifiedFulfilmentUiEnabled ? (
    <FulfilmentSelectUnified {...props} />
  ) : (
    <FulfilmentSelectLegacy {...props} />
  )
}

export type { FulfilmentSelectProps } from '../../../../../../sale/sale-line-item/FulfilmentSelect'
